import { apiInstance } from "../config/api";

export const marketService = {
  async listMarkets() {
    const response = await apiInstance.get("/market-management/markets");
    return response.data;
  },

  async getMarketCategories(marketId: string) {
    const response = await apiInstance.get(
      `/market-management/markets/${marketId}/categories`,
    );
    return response.data;
  },

  async createSellerRequest(payload: {
    profilerId: string;
    marketId: string;
    planId: string;
    shopName: string;
    storeAddress: string;
    note?: string;
    nicheCategoryIds: string[];
  }) {
    const response = await apiInstance.post("/market-management/requests", payload);
    return response.data;
  },

  async getSellerAccount(sellerId: string) {
    const response = await apiInstance.get(`/market-management/sellers/${sellerId}`);
    return response.data;
  },
};